export default __webpack_public_path__ + "static/media/7.7aa5b313.png";